import React from "react";
import TrackPageV3 from "./v3/TrackPageV3";

const WoneIndexRouter: React.FC = () => {
  return <TrackPageV3 />;
};

export default WoneIndexRouter;
